<template>
  <div class="ant-popover ant-popover-placement-bottom"
       style="transform-origin: -50%;"
       :style="menuPosition">
    <div class="ant-popover-content">
      <!-- <div class="ant-popover-arrow"></div> -->
      <div role="tooltip"
           class="ant-popover-inner">
        <div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PPopover",
  props: ['menuPosition'],
  data () {
    return {

    };
  },
  mounted () {
    console.log("position", this.menuPosition)

  },
  methods: {

  },
};
</script>
